// import React, { useState, useEffect } from 'react';
// import {
//   Globe,
//   Facebook,
//   Download,
//   RefreshCw,
//   Calendar,
//   Search,
//   Trash2,
//   Database,
//   Activity
// } from 'lucide-react';
// import { leadsAPI } from '../services/api';

// const UnifiedDashboard = () => {
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [syncing, setSyncing] = useState(false);
//   const [stats, setStats] = useState({
//     total: 0,
//     website: 0,
//     meta: 0,
//     today: 0
//   });
  
//   // Filters
//   const [sourceFilter, setSourceFilter] = useState('all');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [backendStatus, setBackendStatus] = useState('checking');

//   useEffect(() => {
//     checkBackend();
//     loadLeads();
//     loadStats();
    
//     // Auto-refresh every 2 minutes
//     const interval = setInterval(() => {
//       loadLeads();
//       loadStats();
//     }, 120000);
    
//     return () => clearInterval(interval);
//   }, []);

//   const checkBackend = async () => {
//     try {
//       const result = await leadsAPI.checkHealth();
//       setBackendStatus(result.mongodb === 'connected' ? 'connected' : 'disconnected');
//     } catch (error) {
//       setBackendStatus('disconnected');
//     }
//   };

//   const loadLeads = async () => {
//     setLoading(true);
//     try {
//       const result = await leadsAPI.getAllLeads({
//         source: sourceFilter !== 'all' ? sourceFilter : null,
//         startDate,
//         endDate,
//         search: searchQuery
//       });
      
//       if (result.success) {
//         setLeads(result.leads);
//       }
//     } catch (error) {
//       console.error('Failed to load leads:', error);
//       alert('Failed to load leads. Check if backend is running.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStats = async () => {
//     try {
//       const result = await leadsAPI.getStats();
//       if (result.success) {
//         setStats(result.stats);
//       }
//     } catch (error) {
//       console.error('Failed to load stats:', error);
//     }
//   };

//   const handleSync = async () => {
//     if (syncing) return;
    
//     setSyncing(true);
//     try {
//       const result = await leadsAPI.syncMetaLeads();
//       if (result.success) {
//         alert(`✅ Synced ${result.newLeads} new Meta leads!`);
//         loadLeads();
//         loadStats();
//       } else {
//         alert('❌ Sync failed: ' + result.message);
//       }
//     } catch (error) {
//       console.error('Sync failed:', error);
//       alert('❌ Failed to sync. Check your Meta credentials.');
//     } finally {
//       setSyncing(false);
//     }
//   };

//   const handleDelete = async (lead) => {
//     if (!window.confirm(`Delete lead from ${lead.name}?`)) return;
    
//     try {
//       const id = lead.leadId || lead._id;
//       const result = await leadsAPI.deleteLead(id, lead.source);
      
//       if (result.success) {
//         alert('✅ Lead deleted');
//         loadLeads();
//         loadStats();
//       } else {
//         alert('❌ Delete failed');
//       }
//     } catch (error) {
//       console.error('Delete failed:', error);
//       alert('❌ Delete failed');
//     }
//   };

//   const downloadCSV = () => {
//     const headers = ['Date', 'Source', 'Form', 'Name', 'Email', 'Phone', 'Company', 'Message'];
//     const csvData = leads.map(lead => [
//       new Date(lead.displayDate).toLocaleString(),
//       lead.source === 'website' ? 'Website' : 'Meta (Facebook/Instagram)',
//       lead.formName || lead.formSource || '',
//       lead.name,
//       lead.email,
//       lead.phone || lead.mobile || '',
//       lead.company || '',
//       `"${(lead.message || '').replace(/"/g, '""')}"`
//     ].join(','));

//     const csv = [headers.join(','), ...csvData].join('\n');
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `leads_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//   };

//   const applyFilters = () => {
//     loadLeads();
//   };

//   const clearFilters = () => {
//     setSourceFilter('all');
//     setStartDate('');
//     setEndDate('');
//     setSearchQuery('');
//     setTimeout(loadLeads, 100);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       <div className="max-w-7xl mx-auto">
        
//         {/* Header */}
//         <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
//           <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
//             <div>
//               <h1 className="text-3xl font-bold text-gray-900 flex items-center">
//                 <Database className="w-8 h-8 mr-2 text-blue-600" />
//                 Enigoal Leads Dashboard
//               </h1>
//               <div className="flex items-center mt-2 space-x-2">
//                 <div className={`w-2 h-2 rounded-full ${
//                   backendStatus === 'connected' ? 'bg-green-500' : 'bg-red-500'
//                 }`}></div>
//                 <span className="text-sm text-gray-600">
//                   Backend: {backendStatus}
//                 </span>
//               </div>
//             </div>
            
//             <div className="flex flex-wrap gap-2">
//               <button
//                 onClick={handleSync}
//                 disabled={syncing}
//                 className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-blue-700 disabled:opacity-50"
//               >
//                 <RefreshCw className={`w-4 h-4 ${syncing ? 'animate-spin' : ''}`} />
//                 <span>{syncing ? 'Syncing...' : 'Sync Meta'}</span>
//               </button>
              
//               <button
//                 onClick={() => { loadLeads(); loadStats(); }}
//                 className="bg-green-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-green-700"
//               >
//                 <RefreshCw className="w-4 h-4" />
//                 <span>Refresh</span>
//               </button>
              
//               <button
//                 onClick={downloadCSV}
//                 className="bg-purple-600 text-white px-4 py-2 rounded-lg flex items-center space-x-2 hover:bg-purple-700"
//               >
//                 <Download className="w-4 h-4" />
//                 <span>CSV</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6">
//           <div className="bg-white rounded-lg shadow p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-bold text-blue-600">{stats.total}</div>
//                 <div className="text-gray-600 text-sm mt-1">Total Leads</div>
//               </div>
//               <Activity className="w-10 h-10 text-blue-200" />
//             </div>
//           </div>
          
//           <div className="bg-white rounded-lg shadow p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-bold text-green-600">{stats.website}</div>
//                 <div className="text-gray-600 text-sm mt-1 flex items-center">
//                   <Globe className="w-4 h-4 mr-1" />
//                   Website
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-lg shadow p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-bold text-purple-600">{stats.meta}</div>
//                 <div className="text-gray-600 text-sm mt-1 flex items-center">
//                   <Facebook className="w-4 h-4 mr-1" />
//                   Meta Ads
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div className="bg-white rounded-lg shadow p-6">
//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-bold text-orange-600">{stats.today}</div>
//                 <div className="text-gray-600 text-sm mt-1">Today</div>
//               </div>
//               <Calendar className="w-10 h-10 text-orange-200" />
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="bg-white rounded-lg shadow p-6 mb-6">
//           <h3 className="text-lg font-semibold mb-4">Filters</h3>
//           <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//             <div>
//               <label className="block text-sm font-medium mb-2">Source</label>
//               <select
//                 value={sourceFilter}
//                 onChange={(e) => setSourceFilter(e.target.value)}
//                 className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//               >
//                 <option value="all">All Sources</option>
//                 <option value="website">Website Only</option>
//                 <option value="meta">Meta Only</option>
//               </select>
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium mb-2">Start Date</label>
//               <input
//                 type="date"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//                 className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium mb-2">End Date</label>
//               <input
//                 type="date"
//                 value={endDate}
//                 onChange={(e) => setEndDate(e.target.value)}
//                 className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
            
//             <div>
//               <label className="block text-sm font-medium mb-2">Search</label>
//               <input
//                 type="text"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 placeholder="Name, email, phone..."
//                 className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
//               />
//             </div>
            
//             <div className="flex items-end space-x-2">
//               <button
//                 onClick={applyFilters}
//                 className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
//               >
//                 Apply
//               </button>
//               <button
//                 onClick={clearFilters}
//                 className="flex-1 bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
//               >
//                 Clear
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Leads Table */}
//         <div className="bg-white rounded-lg shadow overflow-hidden">
//           <div className="px-6 py-4 border-b border-gray-200">
//             <h3 className="text-lg font-semibold">
//               All Leads ({leads.length})
//             </h3>
//           </div>
          
//           {loading ? (
//             <div className="text-center py-12">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//               <p className="mt-4 text-gray-600">Loading leads...</p>
//             </div>
//           ) : leads.length === 0 ? (
//             <div className="text-center py-12 text-gray-500">
//               <Database className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//               <p className="text-lg font-medium">No leads found</p>
//               <p className="text-sm">Try adjusting your filters or sync Meta leads</p>
//             </div>
//           ) : (
//             <div className="overflow-x-auto">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50">
//                   <tr>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Source</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Form</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Phone</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Company</th>
//                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {leads.map((lead, index) => (
//                     <tr key={lead._id || lead.leadId || index} className="hover:bg-gray-50">
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         {new Date(lead.displayDate).toLocaleDateString()}
//                         <div className="text-xs text-gray-500">
//                           {new Date(lead.displayDate).toLocaleTimeString()}
//                         </div>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap">
//                         <span className={`px-2 py-1 rounded-full text-xs font-medium ${
//                           lead.source === 'website'
//                             ? 'bg-green-100 text-green-800'
//                             : 'bg-purple-100 text-purple-800'
//                         }`}>
//                           {lead.source === 'website' ? (
//                             <span className="flex items-center">
//                               <Globe className="w-3 h-3 mr-1" />
//                               Website
//                             </span>
//                           ) : (
//                             <span className="flex items-center">
//                               <Facebook className="w-3 h-3 mr-1" />
//                               Meta
//                             </span>
//                           )}
//                         </span>
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         {lead.formName || lead.formSource || '-'}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
//                         {lead.name}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         {lead.email}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         {lead.phone || lead.mobile || '-'}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         {lead.company || '-'}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         <button
//                           onClick={() => handleDelete(lead)}
//                           className="text-red-600 hover:text-red-800"
//                           title="Delete lead"
//                         >
//                           <Trash2 className="w-4 h-4" />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnifiedDashboard;


























// import React, { useState, useEffect } from 'react';
// import {
//   Globe,
//   Facebook,
//   Download,
//   RefreshCw,
//   Calendar,
//   Search,
//   Trash2,
//   Database,
//   Activity,
//   Lock,
//   Eye,
//   EyeOff,
//   LogOut,
//   ChevronLeft,
//   ChevronRight,
//   Mail,
//   Phone,
//   Building2
// } from 'lucide-react';
// import { leadsAPI } from '../services/api';

// const UnifiedDashboard = () => {
//   // Authentication
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [loginData, setLoginData] = useState({ username: '', password: '' });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loginError, setLoginError] = useState('');

//   // Data
//   const [leads, setLeads] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [syncing, setSyncing] = useState(false);
//   const [stats, setStats] = useState({
//     total: 0,
//     website: 0,
//     meta: 0,
//     today: 0
//   });
  
//   // Filters
//   const [sourceFilter, setSourceFilter] = useState('all');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [searchQuery, setSearchQuery] = useState('');
//   const [backendStatus, setBackendStatus] = useState('checking');

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [leadsPerPage] = useState(50);
//   const [selectedLeads, setSelectedLeads] = useState([]);

//   // Admin credentials - CHANGE THESE
//   const ADMIN_CREDENTIALS = {
//     username: 'adminpanelx',
//     password: 'Admin@086'
//   };

//   useEffect(() => {
//     const savedAuth = sessionStorage.getItem('dashboardAuth');
//     if (savedAuth === 'true') {
//       setIsAuthenticated(true);
//       checkBackend();
//       loadLeads();
//       loadStats();
//     }
//   }, []);

//   useEffect(() => {
//     if (isAuthenticated) {
//       const interval = setInterval(() => {
//         loadLeads();
//         loadStats();
//       }, 120000);
//       return () => clearInterval(interval);
//     }
//   }, [isAuthenticated]);

//   const handleLogin = (e) => {
//     e.preventDefault();
//     if (loginData.username === ADMIN_CREDENTIALS.username && loginData.password === ADMIN_CREDENTIALS.password) {
//       setIsAuthenticated(true);
//       sessionStorage.setItem('dashboardAuth', 'true');
//       checkBackend();
//       loadLeads();
//       loadStats();
//     } else {
//       setLoginError('Invalid username or password');
//     }
//   };

//   const handleLogout = () => {
//     setIsAuthenticated(false);
//     sessionStorage.removeItem('dashboardAuth');
//     setLoginData({ username: '', password: '' });
//     setLeads([]);
//   };

//   const checkBackend = async () => {
//     try {
//       const result = await leadsAPI.checkHealth();
//       setBackendStatus(result.mongodb === 'connected' ? 'connected' : 'disconnected');
//     } catch (error) {
//       setBackendStatus('disconnected');
//     }
//   };

//   const loadLeads = async () => {
//     setLoading(true);
//     try {
//       const result = await leadsAPI.getAllLeads({
//         source: sourceFilter !== 'all' ? sourceFilter : null,
//         startDate,
//         endDate,
//         search: searchQuery
//       });
      
//       if (result.success) {
//         setLeads(result.leads);
//       }
//     } catch (error) {
//       console.error('Failed to load leads:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadStats = async () => {
//     try {
//       const result = await leadsAPI.getStats();
//       if (result.success) {
//         setStats(result.stats);
//       }
//     } catch (error) {
//       console.error('Failed to load stats:', error);
//     }
//   };

//   const handleSync = async () => {
//     if (syncing) return;
//     setSyncing(true);
//     try {
//       const result = await leadsAPI.syncMetaLeads();
//       if (result.success) {
//         alert(`✅ Synced ${result.newLeads} new Meta leads!`);
//         loadLeads();
//         loadStats();
//       } else {
//         alert('❌ Sync failed: ' + result.message);
//       }
//     } catch (error) {
//       console.error('Sync failed:', error);
//       alert('❌ Failed to sync. Check your Meta credentials.');
//     } finally {
//       setSyncing(false);
//     }
//   };

//   const handleDelete = async (lead) => {
//     if (!window.confirm(`Delete lead from ${lead.name}?`)) return;
    
//     try {
//       const id = lead.leadId || lead._id;
//       const result = await leadsAPI.deleteLead(id, lead.source);
      
//       if (result.success) {
//         alert('✅ Lead deleted');
//         loadLeads();
//         loadStats();
//       } else {
//         alert('❌ Delete failed');
//       }
//     } catch (error) {
//       console.error('Delete failed:', error);
//       alert('❌ Delete failed');
//     }
//   };

//   const downloadCSV = () => {
//     const headers = ['Date', 'Source', 'Form', 'Name', 'Email', 'Phone', 'Company', 'Service', 'Message'];
//     const csvData = leads.map(lead => [
//       new Date(lead.displayDate).toLocaleString(),
//       lead.source === 'website' ? 'Website' : 'Meta',
//       lead.formName || lead.formSource || '',
//       lead.name,
//       lead.email,
//       lead.phone || lead.mobile || '',
//       lead.company || '',
//       lead.service || '',
//       `"${(lead.message || '').replace(/"/g, '""')}"`
//     ].join(','));

//     const csv = [headers.join(','), ...csvData].join('\n');
//     const blob = new Blob([csv], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `leads_${new Date().toISOString().split('T')[0]}.csv`;
//     a.click();
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     loadLeads();
//   };

//   const clearFilters = () => {
//     setSourceFilter('all');
//     setStartDate('');
//     setEndDate('');
//     setSearchQuery('');
//     setCurrentPage(1);
//     setTimeout(loadLeads, 100);
//   };

//   const toggleSelectLead = (id) => {
//     setSelectedLeads(prev =>
//       prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
//     );
//   };

//   const selectAllLeads = () => {
//     if (selectedLeads.length === currentLeads.length) {
//       setSelectedLeads([]);
//     } else {
//       setSelectedLeads(currentLeads.map(l => l._id || l.leadId));
//     }
//   };

//   // Pagination logic
//   const indexOfLastLead = currentPage * leadsPerPage;
//   const indexOfFirstLead = indexOfLastLead - leadsPerPage;
//   const currentLeads = leads.slice(indexOfFirstLead, indexOfLastLead);
//   const totalPages = Math.ceil(leads.length / leadsPerPage);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   // Login Screen
//   if (!isAuthenticated) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 flex items-center justify-center p-4">
//         <div className="absolute inset-0 bg-black/20"></div>
//         <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500/30 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse"></div>

//         <div className="relative bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 w-full max-w-md border border-white/20">
//           <div className="text-center mb-8">
//             <div className="inline-flex items-center justify-center w-30 h-20 bg-gradient-to-br from-gray-50 to-gray-50 rounded-2xl mb-4 shadow-lg">
             
//   <img 
//     src="/logo.png"        // 👉 replace with the correct path to your logo file
//     alt="Company Logo" 
//     className="w-30 h-20 object-contain" 
//   />
//             </div>
//             <h1 className="text-3xl font-bold text-gray-900 mb-2">Enigoal Leads Dashboard</h1>
//             <p className="text-gray-600">Sign in to access your dashboard</p>
//           </div>

//           <form onSubmit={handleLogin} className="space-y-6">
//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Username</label>
//               <input
//                 type="text"
//                 value={loginData.username}
//                 onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
//                 className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none"
//                 placeholder="Enter username"
//                 required
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
//               <div className="relative">
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   value={loginData.password}
//                   onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
//                   className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none pr-12"
//                   placeholder="Enter password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                 >
//                   {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
//                 </button>
//               </div>
//             </div>

//             {loginError && (
//               <div className="bg-red-50 border-2 border-red-200 text-red-700 px-4 py-3 rounded-xl">
//                 {loginError}
//               </div>
//             )}

//             <button
//               type="submit"
//               className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl transition-all shadow-lg hover:shadow-xl"
//             >
//               Sign In
//             </button>
//           </form>

         
//         </div>
//       </div>
//     );
//   }

//   // Main Dashboard
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
//       {/* Top Navigation */}
//       <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
//         <div className="px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="flex items-center space-x-3">
//                 {/* <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
//                   <Database className="w-6 h-6 text-white" />
//                 </div> */}
//                 <div className="w-30 h-10 bg-gradient-to-br from-white-600 to-white-600 rounded-xl flex items-center justify-center shadow-lg">
//   <img 
//     src="/logo.png"        // 👉 replace with the correct path to your logo file
//     alt="Company Logo" 
//     className="w-30 h-20 object-contain" 
//   />
// </div>

//                 <div>
//                   <h1 className="text-xl font-bold text-gray-900">Enigoal Leads Dashboard</h1>
//                   <div className="flex items-center space-x-3 text-xs">
//                     <span className="flex items-center text-green-600">
//                       <div className="w-2 h-2 bg-green-500 rounded-full mr-1 animate-pulse"></div>
//                       Backend: connected
//                     </span>
//                     <span className="flex items-center text-green-600">
//                       <div className="w-2 h-2 bg-green-500 rounded-full mr-1 animate-pulse"></div>
//                       MongoDB: {backendStatus}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center space-x-3">
//               <button
//                 onClick={handleSync}
//                 disabled={syncing}
//                 className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg disabled:opacity-50"
//               >
//                 <RefreshCw className={`w-4 h-4 ${syncing ? 'animate-spin' : ''}`} />
//                 <span className="hidden md:inline">{syncing ? 'Syncing...' : 'Refresh'}</span>
//               </button>
              
//               <button
//                 onClick={downloadCSV}
//                 className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
//               >
//                 <Download className="w-4 h-4" />
//                 <span className="hidden md:inline">Download CSV</span>
//               </button>

//               {selectedLeads.length > 0 && (
//                 <button
//                   className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
//                 >
//                   <Trash2 className="w-4 h-4" />
//                   <span className="hidden md:inline">Delete ({selectedLeads.length})</span>
//                 </button>
//               )}

//               <button
//                 onClick={handleLogout}
//                 className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
//               >
//                 <LogOut className="w-4 h-4" />
//                 <span className="hidden md:inline">Logout</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </nav>

//       <div className="p-6 max-w-7xl mx-auto space-y-6">
//         {/* Stats Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
//                 <Activity className="w-6 h-6 text-blue-600" />
//               </div>
//             </div>
//             <div className="text-3xl font-bold text-gray-900">{stats.total}</div>
//             <div className="text-sm text-gray-600 mt-1">Total</div>
//           </div>

//           <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
//                 <Globe className="w-6 h-6 text-green-600" />
//               </div>
//             </div>
//             <div className="text-3xl font-bold text-gray-900">{stats.website}</div>
//             <div className="text-sm text-gray-600 mt-1">Website</div>
//           </div>

//           <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
//                 <Facebook className="w-6 h-6 text-purple-600" />
//               </div>
//             </div>
//             <div className="text-3xl font-bold text-gray-900">{stats.meta}</div>
//             <div className="text-sm text-gray-600 mt-1">Meta</div>
//           </div>

//           <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
//             <div className="flex items-center justify-between mb-4">
//               <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
//                 <Calendar className="w-6 h-6 text-orange-600" />
//               </div>
//             </div>
//             <div className="text-3xl font-bold text-gray-900">{stats.today}</div>
//             <div className="text-sm text-gray-600 mt-1">Today</div>
//           </div>
//         </div>

//         {/* Search and Filters */}
//         <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
//           <div className="space-y-4">
//             <div className="relative">
//               <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
//               <input
//                 type="text"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 placeholder="Search by name, email, company, phone, or message..."
//                 className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none"
//               />
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
//                 <input
//                   type="date"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
//                 <input
//                   type="date"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Form Type</label>
//                 <select
//                   value={sourceFilter}
//                   onChange={(e) => setSourceFilter(e.target.value)}
//                   className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
//                 >
//                   <option value="all">All Forms ({stats.total})</option>
//                   <option value="website">Website Only</option>
//                   <option value="meta">Meta Only</option>
//                 </select>
//               </div>

//               <div className="md:col-span-2 flex items-end space-x-2">
//                 <button
//                   onClick={applyFilters}
//                   className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all font-medium"
//                 >
//                   Apply Filter
//                 </button>
//                 <button
//                   onClick={clearFilters}
//                   className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-xl transition-all"
//                 >
//                   Clear
//                 </button>
//               </div>
//             </div>

//             <div className="flex items-center justify-between">
//               <button
//                 onClick={selectAllLeads}
//                 className="text-sm text-blue-600 hover:text-blue-800 underline"
//               >
//                 {selectedLeads.length === currentLeads.length ? 'Deselect All' : 'Select All'}
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Leads Cards - No Horizontal Scroll */}
//         <div className="space-y-4">
//           {loading ? (
//             <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//               <p className="mt-4 text-gray-600">Loading from MongoDB...</p>
//             </div>
//           ) : currentLeads.length === 0 ? (
//             <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
//               <Database className="w-16 h-16 text-gray-300 mx-auto mb-4" />
//               <p className="text-lg font-medium text-gray-900">No submissions found</p>
//               <p className="text-sm text-gray-600">Try adjusting your search criteria</p>
//             </div>
//           ) : (
//             <>
//               {currentLeads.map((lead, index) => (
//                 <div key={lead._id || lead.leadId || index} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all">
//                   <div className="flex items-start justify-between mb-4">
//                     <div className="flex items-center space-x-3">
//                       <input
//                         type="checkbox"
//                         checked={selectedLeads.includes(lead._id || lead.leadId)}
//                         onChange={() => toggleSelectLead(lead._id || lead.leadId)}
//                         className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
//                       />
//                       <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase ${
//                         lead.source === 'website' || lead.formSource === 'getstarted'
//                           ? 'bg-green-100 text-green-800'
//                           : lead.formSource === 'contact'
//                           ? 'bg-purple-100 text-purple-800'
//                           : 'bg-orange-100 text-orange-800'
//                       }`}>
//                         {lead.formSource || lead.formName || lead.source}
//                       </span>
//                       <span className="text-sm text-gray-500">
//                         {new Date(lead.displayDate || lead.submittedAt || lead.createdAt).toLocaleString()}
//                       </span>
//                     </div>
//                     <button
//                       onClick={() => handleDelete(lead)}
//                       className="text-red-600 hover:text-red-800 transition-colors"
//                       title="Delete submission"
//                     >
//                       <Trash2 className="w-4 h-4" />
//                     </button>
//                   </div>

//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                     <div>
//                       <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
//                         <span>Name:</span>
//                       </div>
//                       <p className="text-gray-900">{lead.name || 'N/A'}</p>
//                     </div>

//                     <div>
//                       <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
//                         <Mail className="w-4 h-4 mr-1" />
//                         Email:
//                       </div>
//                       <p className="text-gray-900 break-all">{lead.email || 'N/A'}</p>
//                     </div>

//                     <div>
//                       <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
//                         <Phone className="w-4 h-4 mr-1" />
//                         Phone:
//                       </div>
//                       <p className="text-gray-900">{lead.phone || lead.mobile || 'N/A'}</p>
//                     </div>

//                     {lead.company && (
//                       <div>
//                         <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
//                           <Building2 className="w-4 h-4 mr-1" />
//                           Company:
//                         </div>
//                         <p className="text-gray-900">{lead.company}</p>
//                       </div>
//                     )}

//                     {lead.companyReg && (
//                       <div>
//                         <strong className="text-gray-700 text-sm">Company Status:</strong>
//                         <p className="text-gray-900">{lead.companyReg}</p>
//                       </div>
//                     )}

//                     {lead.service && (
//                       <div>
//                         <strong className="text-gray-700 text-sm">Service Interest:</strong>
//                         <p className="text-gray-900">{lead.service}</p>
//                       </div>
//                     )}
//                   </div>

//                   {lead.message && (
//                     <div className="mt-4 pt-4 border-t border-gray-200">
//                       <strong className="text-gray-700 text-sm">Message:</strong>
//                       <p className="text-gray-900 mt-1">{lead.message}</p>
//                     </div>
//                   )}

//                   <div className="mt-2 text-xs text-gray-500">
//                     ID: {lead._id || lead.leadId}
//                   </div>
//                 </div>
//               ))}

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="bg-white rounded-2xl shadow-lg p-4 flex items-center justify-between">
//                   <div className="text-sm text-gray-600">
//                     Showing {indexOfFirstLead + 1} to {Math.min(indexOfLastLead, leads.length)} of {leads.length} leads
//                   </div>

//                   <div className="flex items-center space-x-2">
//                     <button
//                       onClick={() => paginate(currentPage - 1)}
//                       disabled={currentPage === 1}
//                       className="px-3 py-2 bg-gray-600 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-all flex items-center space-x-1"
//                     >
//                       <ChevronLeft className="w-4 h-4" />
//                       <span className="hidden md:inline">Previous</span>
//                     </button>

//                     <div className="flex items-center space-x-1">
//                       {[...Array(totalPages)].map((_, i) => (
//                         <button
//                           key={i + 1}
//                           onClick={() => paginate(i + 1)}
//                           className={`px-3 py-2 rounded-lg transition-all ${
//                             currentPage === i + 1
//                               ? 'bg-blue-600 text-white'
//                               : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                           }`}
//                         >
//                           {i + 1}
//                         </button>
//                       ))}
//                     </div>

//                     <button
//                       onClick={() => paginate(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                       className="px-3 py-2 bg-gray-600 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-all flex items-center space-x-1"
//                     >
//                       <span className="hidden md:inline">Next</span>
//                       <ChevronRight className="w-4 h-4" />
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UnifiedDashboard;
































































import React, { useState, useEffect } from 'react';
import {
  Globe,
  Facebook,
  Download,
  RefreshCw,
  Calendar,
  Search,
  Trash2,
  Database,
  Activity,
  Lock,
  Eye,
  EyeOff,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Mail,
  Phone,
  Building2
} from 'lucide-react';
import { leadsAPI } from '../services/api';

const UnifiedDashboard = () => {
  // Authentication
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');

  // Data
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    website: 0,
    meta: 0,
    today: 0
  });
  
  // Filters
  const [sourceFilter, setSourceFilter] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [backendStatus, setBackendStatus] = useState('checking');

  // Pagination
  // Pagination toggle
const [paginationEnabled, setPaginationEnabled] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [leadsPerPage] = useState(20);
  const [selectedLeads, setSelectedLeads] = useState([]);

  // Admin credentials - CHANGE THESE
  const ADMIN_CREDENTIALS = {
    username: 'enigoalleadx',
    password: 'Leads@086'
  };

  useEffect(() => {
    const savedAuth = sessionStorage.getItem('dashboardAuth');
    if (savedAuth === 'true') {
      setIsAuthenticated(true);
      checkBackend();
      loadLeads();
      loadStats();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const interval = setInterval(() => {
        loadLeads();
        loadStats();
      }, 120000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (loginData.username === ADMIN_CREDENTIALS.username && loginData.password === ADMIN_CREDENTIALS.password) {
      setIsAuthenticated(true);
      sessionStorage.setItem('dashboardAuth', 'true');
      checkBackend();
      loadLeads();
      loadStats();
    } else {
      setLoginError('Invalid username or password');
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('dashboardAuth');
    setLoginData({ username: '', password: '' });
    setLeads([]);
  };

  const checkBackend = async () => {
    try {
      const result = await leadsAPI.checkHealth();
      setBackendStatus(result.mongodb === 'connected' ? 'connected' : 'disconnected');
    } catch (error) {
      setBackendStatus('disconnected');
    }
  };

  const loadLeads = async () => {
    setLoading(true);
    try {
      const result = await leadsAPI.getAllLeads({
        source: sourceFilter !== 'all' ? sourceFilter : null,
        startDate,
        endDate,
        search: searchQuery
      });
      
      if (result.success) {
        setLeads(result.leads);
      }
    } catch (error) {
      console.error('Failed to load leads:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadStats = async () => {
    try {
      const result = await leadsAPI.getStats();
      if (result.success) {
        setStats(result.stats);
      }
    } catch (error) {
      console.error('Failed to load stats:', error);
    }
  };

  const handleSync = async () => {
    if (syncing) return;
    setSyncing(true);
    try {
      const result = await leadsAPI.syncMetaLeads();
      if (result.success) {
        alert(`✅ Synced ${result.newLeads} new Meta leads!`);
        loadLeads();
        loadStats();
      } else {
        alert('❌ Sync failed: ' + result.message);
      }
    } catch (error) {
      console.error('Sync failed:', error);
      alert('❌ Failed to sync. Check your Meta credentials.');
    } finally {
      setSyncing(false);
    }
  };

  const handleDelete = async (lead) => {
    if (!window.confirm(`Delete lead from ${lead.name}?`)) return;
    
    try {
      const id = lead.leadId || lead._id;
      const result = await leadsAPI.deleteLead(id, lead.source);
      
      if (result.success) {
        alert('✅ Lead deleted');
        loadLeads();
        loadStats();
      } else {
        alert('❌ Delete failed');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      alert('❌ Delete failed');
    }
  };

  const downloadCSV = () => {
    const headers = ['Date','Time', 'Source', 'Form', 'Name', 'Email', 'Phone', 'Company', 'Service', 'Message'];
    const csvData = leads.map(lead => [
      new Date(lead.displayDate).toLocaleString(),
      lead.source === 'website' ? 'Website' : 'Meta',
      lead.formName || lead.formSource || '',
      lead.name,
      lead.email,
      lead.phone || lead.mobile || '',
      lead.company || '',
      lead.service || '',
      `"${(lead.message || '').replace(/"/g, '""')}"`
    ].join(','));

    const csv = [headers.join(','), ...csvData].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `leads_${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
  };

  const applyFilters = () => {
    setCurrentPage(1);
    loadLeads();
  };

  const clearFilters = () => {
    setSourceFilter('all');
    setStartDate('');
    setEndDate('');
    setSearchQuery('');
    setCurrentPage(1);
    setTimeout(loadLeads, 100);
  };

  const toggleSelectLead = (id) => {
    setSelectedLeads(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const selectAllLeads = () => {
    if (selectedLeads.length === currentLeads.length) {
      setSelectedLeads([]);
    } else {
      setSelectedLeads(currentLeads.map(l => l._id || l.leadId));
    }
  };

  // Pagination logic
  // Pagination variables
const indexOfLastLead = currentPage * leadsPerPage;
const indexOfFirstLead = indexOfLastLead - leadsPerPage;
const currentLeads = paginationEnabled 
  ? leads.slice(indexOfFirstLead, indexOfLastLead)
  : leads;

// Total pages
const totalPages = Math.ceil(leads.length / leadsPerPage);

// Function to change page
const paginate = (pageNumber) => {
  if (pageNumber < 1 || pageNumber > totalPages) return;
  setCurrentPage(pageNumber);
};



  // Login Screen
  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/30 rounded-full blur-3xl animate-pulse"></div>

        <div className="relative bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 w-full max-w-md border border-white/20">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-30 h-20 bg-gradient-to-br from-gray-50 to-gray-50 rounded-2xl mb-4 shadow-lg">
             
  <img 
    src="/logo.png"        // 👉 replace with the correct path to your logo file
    alt="Company Logo" 
    className="w-30 h-20 object-contain" 
  />
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Enigoal Leads Dashboard</h1>
            <p className="text-gray-600">Sign in to access your dashboard</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Username</label>
              <input
                type="text"
                value={loginData.username}
                onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none"
                placeholder="Enter username"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={loginData.password}
                  onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                  className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none pr-12"
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {loginError && (
              <div className="bg-red-50 border-2 border-red-200 text-red-700 px-4 py-3 rounded-xl">
                {loginError}
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold py-3 rounded-xl transition-all shadow-lg hover:shadow-xl"
            >
              Sign In
            </button>
          </form>

         
        </div>
      </div>
    );
  }

  // Main Dashboard
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Top Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-3">
                {/* <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
                  <Database className="w-6 h-6 text-white" />
                </div> */}
                <div className="w-30 h-10 bg-gradient-to-br from-white-600 to-white-600 rounded-xl flex items-center justify-center shadow-lg">
  <img 
    src="/logo.png"        // 👉 replace with the correct path to your logo file
    alt="Company Logo" 
    className="w-30 h-20 object-contain" 
  />
</div>

                <div>
                  <h1 className="text-xl font-bold text-gray-900">Enigoal Leads Dashboard</h1>
                  <div className="flex items-center space-x-3 text-xs">
                    <span className="flex items-center text-green-600">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-1 animate-pulse"></div>
                      Backend: connected
                    </span>
                    <span className="flex items-center text-green-600">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-1 animate-pulse"></div>
                      MongoDB: {backendStatus}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <button
                onClick={handleSync}
                disabled={syncing}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg disabled:opacity-50"
              >
                <RefreshCw className={`w-4 h-4 ${syncing ? 'animate-spin' : ''}`} />
                <span className="hidden md:inline">{syncing ? 'Syncing...' : 'Refresh'}</span>
              </button>
              
              <button
                onClick={downloadCSV}
                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
              >
                <Download className="w-4 h-4" />
                <span className="hidden md:inline">Download CSV</span>
              </button>

              {selectedLeads.length > 0 && (
                <button
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
                >
                  <Trash2 className="w-4 h-4" />
                  <span className="hidden md:inline">Delete ({selectedLeads.length})</span>
                </button>
              )}

              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center space-x-2 transition-all shadow-md hover:shadow-lg"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden md:inline">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="p-6 max-w-7xl mx-auto space-y-6">
        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <Activity className="w-6 h-6 text-blue-600" />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">{stats.total}</div>
            <div className="text-sm text-gray-600 mt-1">Total</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                <Globe className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">{stats.website}</div>
            <div className="text-sm text-gray-600 mt-1">Website</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
                <Facebook className="w-6 h-6 text-purple-600" />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">{stats.meta}</div>
            <div className="text-sm text-gray-600 mt-1">Meta</div>
          </div>

          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:shadow-xl transition-all">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                <Calendar className="w-6 h-6 text-orange-600" />
              </div>
            </div>
            <div className="text-3xl font-bold text-gray-900">{stats.today}</div>
            <div className="text-sm text-gray-600 mt-1">Today</div>
          </div>
        </div>

        {/* Search and Filters */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
          <div className="space-y-4">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search by name, email, company, phone, or message..."
                className="w-full pl-12 pr-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:bg-white transition-all outline-none"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Form Type</label>
                <select
                  value={sourceFilter}
                  onChange={(e) => setSourceFilter(e.target.value)}
                  className="w-full px-4 py-2 bg-gray-50 border-2 border-gray-200 rounded-xl focus:border-blue-500 transition-all outline-none"
                >
                  <option value="all">All Forms ({stats.total})</option>
                  <option value="website">Website Only</option>
                  <option value="meta">Meta Only</option>
                </select>
              </div>

              <div className="md:col-span-2 flex items-end space-x-2">
                <button
                  onClick={applyFilters}
                  className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all font-medium"
                >
                  Apply Filter
                </button>
                <button
                  onClick={clearFilters}
                  className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-xl transition-all"
                >
                  Clear
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <button
                onClick={selectAllLeads}
                className="text-sm text-blue-600 hover:text-blue-800 underline"
              >
                {selectedLeads.length === currentLeads.length ? 'Deselect All' : 'Select All'}
              </button>
            </div>
          </div>
        </div>
              {/* Pagination Controls */}
<div className="bg-white rounded-2xl shadow-lg p-4 flex items-center justify-between">
  <div className="text-sm text-gray-600">
    Showing {paginationEnabled ? `${indexOfFirstLead + 1} to ${Math.min(indexOfLastLead, leads.length)} of ${leads.length}` : `${leads.length}`} leads
  </div>

  <div className="flex items-center space-x-4">
    {/* ✅ Pagination Toggle */}
    <label className="flex items-center space-x-2 text-sm text-gray-700">
      <input
        type="checkbox"
        checked={paginationEnabled}
        onChange={(e) => {
          setPaginationEnabled(e.target.checked);
          setCurrentPage(1);
        }}
        className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
      />
      <span>Enable Pagination</span>
    </label>

    {/* ✅ Previous / Next Only */}
    {paginationEnabled && totalPages > 1 && (
      <div className="flex items-center space-x-2">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-2 bg-gray-600 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-all flex items-center space-x-1"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="hidden md:inline">Previous</span>
        </button>

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-2 bg-gray-600 text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-700 transition-all flex items-center space-x-1"
        >
          <span className="hidden md:inline">Next</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    )}
  </div>
</div>
        {/* Leads Cards - No Horizontal Scroll */}
        <div className="space-y-4">
          {loading ? (
            <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Loading from MongoDB...</p>
            </div>
          ) : currentLeads.length === 0 ? (
            <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
              <Database className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-lg font-medium text-gray-900">No submissions found</p>
              <p className="text-sm text-gray-600">Try adjusting your search criteria</p>
            </div>
          ) : (
            <>
              {currentLeads.map((lead, index) => (
                <div key={lead._id || lead.leadId || index} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center space-x-3">
                      <input
                        type="checkbox"
                        checked={selectedLeads.includes(lead._id || lead.leadId)}
                        onChange={() => toggleSelectLead(lead._id || lead.leadId)}
                        className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className={`px-3 py-1 rounded-full text-xs font-semibold uppercase ${
                        lead.source === 'website' || lead.formSource === 'getstarted'
                          ? 'bg-green-100 text-green-800'
                          : lead.formSource === 'contact'
                          ? 'bg-purple-100 text-purple-800'
                          : 'bg-orange-100 text-orange-800'
                      }`}>
                        {lead.formSource || lead.formName || lead.source}
                      </span>
                      <span className="text-sm text-gray-500">
                        {new Date(lead.displayDate || lead.submittedAt || lead.createdAt).toLocaleString()}
                      </span>
                    </div>
                    <button
                      onClick={() => handleDelete(lead)}
                      className="text-red-600 hover:text-red-800 transition-colors"
                      title="Delete submission"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div>
                      <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
                        <span>Name:</span>
                      </div>
                      <p className="text-gray-900">{lead.name || 'N/A'}</p>
                    </div>

                    <div>
                      <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
                        <Mail className="w-4 h-4 mr-1" />
                        Email:
                      </div>
                      <p className="text-gray-900 break-all">{lead.email || 'N/A'}</p>
                    </div>

                    <div>
                      <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
                        <Phone className="w-4 h-4 mr-1" />
                        Phone:
                      </div>
                      <p className="text-gray-900">{lead.phone || lead.mobile || 'N/A'}</p>
                    </div>

                    {lead.company && (
                      <div>
                        <div className="flex items-center text-gray-700 font-semibold text-sm mb-1">
                          <Building2 className="w-4 h-4 mr-1" />
                          Company:
                        </div>
                        <p className="text-gray-900">{lead.company}</p>
                      </div>
                    )}

                    {lead.companyReg && (
                      <div>
                        <strong className="text-gray-700 text-sm">Company Status:</strong>
                        <p className="text-gray-900">{lead.companyReg}</p>
                      </div>
                    )}

                    {lead.service && (
                      <div>
                        <strong className="text-gray-700 text-sm">Service Interest:</strong>
                        <p className="text-gray-900">{lead.service}</p>
                      </div>
                    )}
                  </div>

                  {lead.message && (
                    <div className="mt-4 pt-4 border-t border-gray-200">
                      <strong className="text-gray-700 text-sm">Message:</strong>
                      <p className="text-gray-900 mt-1">{lead.message}</p>
                    </div>
                  )}

                  <div className="mt-2 text-xs text-gray-500">
                    ID: {lead._id || lead.leadId}
                  </div>
                </div>
              ))}

              {/* Pagination */}
              

            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnifiedDashboard;